module.exports = __webpack_public_path__ + "img/timeline.af44b3e5.jpg";